import { TASKS_PAGE } from '@/common/constants/pages';
import { ProductType } from '@/product/constants/productTypes';
import { WidgetTemplateName } from '@/widget/constants/WidgetTemplateName';
import URLBuilder from '../network/URLBuilder';
export const getURLPrefixForProductType = (productType) => {
    switch (productType) {
        case ProductType.Jewelry:
            return 'jewelry';
        case ProductType.Rough:
        case ProductType.LGDRough:
            return 'rough';
        case ProductType.Gem:
            return 'gem';
        default:
            return 'diamond'; // ignore 'diamond-colorless' or 'diamond-fancy', just 'diamond'
    }
};
export default class URLProvider {
    static productEditPage(product) {
        return `/${product.entityType}/edit/${product.id}`;
    }
    static productDetailPage(product = null, setupPreset = null, gasolineMovieType = null) {
        if (!product || product.isReference) {
            return '';
        }
        if (product.id && product.type) {
            const urlPrefix = getURLPrefixForProductType(product.type);
            const nextParams = {};
            if (setupPreset?.id) {
                nextParams['sp'] = setupPreset.id;
            }
            if (gasolineMovieType) {
                nextParams['movie'] = gasolineMovieType;
            }
            if (URLBuilder.params().debug === '1') {
                nextParams['debug'] = '1';
            }
            if (URLBuilder.params().meta === '1') {
                nextParams['meta'] = '1';
            }
            return `/${urlPrefix}/${product.id}${URLBuilder.buildQueryString(nextParams)}`;
        }
        return '';
    }
    static comparisonPage(ids, productType) {
        const productsURIPart = ids ? ids.map((id) => `id[]=${id}`).join('&') : '';
        return `/compare/${productType}${productsURIPart ? `?${productsURIPart}` : ''}`;
    }
    static referenceComparisonPage(productId, productType) {
        return `/compare/reference/${productType}/${productId}`;
    }
    static solutionsPage(project) {
        return `/projects/${project.id}/solutions`;
    }
    static activeSolutionPage(project, solution) {
        if (!project.cbr) {
            return URLProvider.solutionsPage(project);
        }
        const id = solution.guid ? solution.guid : solution.id;
        return `/projects/${project.id}/solutions?activeSolutionId=${id}`;
    }
    static projectsPage() {
        return '/projects';
    }
    static tasksPage(filter = {}) {
        return `${TASKS_PAGE}${URLBuilder.buildQueryString(filter)}`;
    }
    static sharedWithMeProjectsPage() {
        return '/shared-with-me-projects';
    }
    static profile(user) {
        if (user.isAnonymous) {
            return '';
        }
        return '/profile';
    }
    static collectionDetailPage(collection) {
        return `/~${collection.id}`;
    }
    static collectionEditPage(collection) {
        return `/~${collection.id}/edit`;
    }
    static customGradingCollectionPage(collectionId, customGradeCode) {
        return `/grading/custom/${customGradeCode}?c=${collectionId}`;
    }
    static customGradingDiamondPage(diamondId, customGradeCode) {
        return `/grading/custom/${customGradeCode}?id[]=${diamondId}`;
    }
    static backOfficePage(productType) {
        return `/catalog/${productType}/edit`;
    }
    static productQcPage(productId1, productId2) {
        return URLBuilder.buildUrl('/api/internal/qc', { url1: productId1, url2: productId2 });
    }
    static adminPage() {
        return URLBuilder.buildUrl('/', {}, 'admin');
    }
    static widgetUrl(templateName, productId, params = {}) {
        if (templateName === WidgetTemplateName.Basic) {
            return URLBuilder.buildUrl(`${templateName}/${productId}`, params, 'widget-v3');
        }
        if (templateName === WidgetTemplateName.RapNet || templateName === WidgetTemplateName.Video) {
            return URLBuilder.buildUrl(`${templateName}/${productId}`, params, 'widget');
        }
        return URLBuilder.buildUrl(`${templateName}/v1/${productId}`, params, 'widget');
    }
    static convertRelativeToAbsolute(url) {
        return `${window.location.origin}${url}`;
    }
    static convertToRelativeLink(absoluteLink) {
        return new URL(absoluteLink).pathname;
    }
}
